import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree } from '@angular/router';

import { SnSessionService } from '@lib/auth';

@Injectable({
  providedIn: 'root',
})
export class FmJwtGuard implements CanActivate {
  constructor(private readonly _sessionService: SnSessionService) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Promise<boolean> {
    if (route.fragment) {
      this._sessionService.setToken(route.fragment);
      return true;
    }
    return true;
  }
}
